import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-back",
  "use": "arrow-back-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"arrow-back\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m7.83 11 5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol